<template>
    <div style="background:#fff; height:100%;">
        <div v-if="loading" class="py-12 text-center d-flex justify-center fill-height align-center">
            <v-progress-circular
                    :size="50"
                    :width="5"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <v-card color="white" flat tile v-else>
            <v-dialog v-model="reviewObj.showReviewDialog" persistent max-width="600" class="white">
                <add-review
                :key="Math.floor(Math.random() * 10)"
                :appointmentId="appointmentDetails.id"
                    @review-added="dismissReview" 
                    @cancel="dismissReview"
                ></add-review>
            </v-dialog>
            <v-dialog v-model="cancelDetails.showDialog" persistent max-width="320">
                    <v-card>
                        <v-card-title class="headline">Cancel Appointment</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-select 
                                        :items="cancelDetails.reasons" 
                                        label="Reason" 
                                        dense 
                                        v-model="cancelDetails.selected_reason"
                                        name="reason" 
                                        outlined
                                        return-object                                
                                        placeholder="Select Reason"
                                        item-text="value" 
                                        hide-details
                                        item-value="id"
                                        :error-messages="errors" 
                                        required
                                    >
                                    </v-select>
                                </v-col>
                                <v-col cols="12" v-if="cancelDetails.selected_reason && cancelDetails.selected_reason.action=='other'" class="mt-0">                                    
                                    <v-text-field 
                                        type="text" 
                                        hide-details
                                        label="Mention your reason" 
                                        dense 
                                        v-model="cancelDetails.other_reason"                                        
                                        outlined                                        
                                        :error-messages="errors" required>
                                    </v-text-field>
                                
                                </v-col>
                                <v-col cols="12" class="mt-0">     
                                    <v-textarea
                                        
                                        v-model="cancelDetails.description"                                        
                                        label="Description"
                                        auto-grow
                                        outlined
                                        rows="2"
                                        
                                    >
                                    </v-textarea>                               
                                    
                                
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" :disabled="cancelAppointmentLoading" text @click="cancelDetails.showDialog = false">No</v-btn>
                        <v-btn color="green darken-1" :loading="cancelAppointmentLoading" :disabled="isConfirmCancelButtonDisabled()"  text @click="cancelAppointment">Yes</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            
          <v-dialog v-model="openTicketDialog" persistent max-width="600">
            <open-ticket :key="openTicketDialog+'ticket'" @closeDialog="closeTicketDialog" :appointmentId="appointmentDetails.id"></open-ticket>
          </v-dialog>
          <v-snackbar right top v-model="showTicketSnackbar">
            A ticket has been raised to the Admin team successfully
          </v-snackbar>
            <v-dialog v-model="cancelAppointmentDialog" persistent max-width="400">            
                        <v-card>
                            <v-card-title class="headline">Cancel Appointment</v-card-title>
                            <v-card-text>Are you sure you want to cancel this appointment.</v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" v-if="!cancelAppointmentLoading" text @click="cancelAppointmentDialog = false">No</v-btn>
                            <v-btn color="green darken-1" :loading="cancelAppointmentLoading" text @click="cancelAppointment">Yes</v-btn>
                            </v-card-actions>
                        </v-card>
            </v-dialog>
            <v-dialog v-model="noteDialog" persistent max-width="400">            
                <v-card>
                    <v-card-title class="headline">Appointment Note</v-card-title>
                    <v-card-text v-if="appointmentDetails.note"> {{appointmentDetails.note.note}} </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>                
                    <v-btn color="green darken-1" text @click="noteDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-card-text class="pa-0">
                <v-list v-if="appointmentDetails.doctor" class="wrap-normal-list">
                    <v-list-item>
                        <v-list-item-content>
                            <div class="d-flex justify-space-between" >
                                <v-list-item-title style="flex-basis:auto">
                                    <v-chip class="white--text" label
                                            v-if="appointmentDetails.status === 1"
                                            color="teal">
                                        Confirmed
                                    </v-chip>
                                    <v-chip class="white--text" label
                                            v-else-if="appointmentDetails.status === 2"
                                            color="red">
                                        Rejected
                                    </v-chip>
                                    <v-chip class="white--text" label
                                            v-else-if="!appointmentDetails.status"
                                            color="orange">
                                        Pending
                                    </v-chip>
                                    <v-chip class="white--text" label
                                            v-else-if="appointmentDetails.status === 3"
                                            color="green">
                                        Cancelled
                                    </v-chip>
                                    <v-chip class="white--text" label
                                            v-else-if="appointmentDetails.status === 4"
                                            color="green">
                                        Completed
                                    </v-chip>
                                                                    
                                    
                                </v-list-item-title>
                              <div class="d-flex flex-wrap ml-1">
                                  
                                    <v-btn 
                                    v-if="1==0" 
                                    @click="noteDialog = true" 
                                    outlined 
                                    color="red" 
                                    small>View Note</v-btn>                            

                                    <v-btn                               
                                    v-if="canReschedule(appointmentDetails)"
                                    class="mr-2"
                                    @click="showRescheduleDialog = true" 
                                    outlined 
                                    color="red" 
                                    small>Reschedule</v-btn>                         
                                    <v-btn 
                                    v-if="canShowMarkAsComplete(appointmentDetails)" 
                                    @click="markAsComplete()" 
                                    outlined 
                                    small
                                    :loading="completeLoader"
                                    class="mr-2">Mark As Complete</v-btn>   
                                    
                                    <v-btn 
                                    v-if="shouldShowCancel(appointmentDetails)" 
                                    @click="showCancelAppointmentDialog(appointmentDetails)" 
                                    outlined 
                                    small
                                    color="red" 
                                    class="mr-2">Cancel</v-btn>

                                    <v-btn 
                                        outlined 
                                        color="blue"
                                        small
                                        v-if="canInitiateCall(appointmentDetails) && !hideVideoCall"
                                        @click.prevent="gotoVideo(appointmentDetails)"> Start Call
                                    </v-btn>
                                    <v-btn 
                                        outlined 
                                        color="blue"
                                        small
                                        v-if="canGiveFeedback(appointmentDetails)"
                                        @click.prevent="showReview"> Rate your experience
                                    </v-btn>
                              </div>
                            </div>
                        </v-list-item-content>
                    </v-list-item>            
                    <v-list-item v-if="appointmentDetails.cancel_request !== null">
                        {{ cancelRequestMessage() }}
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item two-line class="py-2" @click="showDoctorDetails()">
                        <v-list-item-icon>
                            <v-icon>mdi-doctor</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="font-20">
                                {{appointmentDetails.doctor.salutation}}
                                {{appointmentDetails.doctor.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{appointmentDetails.doctor.mobile}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item two-line>
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{appointmentDetails.patient.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{appointmentDetails.patient.mobile}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-range</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ dateutils.utcToLocal(appointmentDetails.start_time).format('hh:mm A')}}
                                -
                                {{ dateutils.utcToLocal(appointmentDetails.end_time).format('hh:mm A')}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ dateutils.utcToLocal(appointmentDetails.start_time).format('dddd, D MMMM YYYY')
                                }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                            :two-line="appointmentDetails.type === 'online'"
                            :three-line="!appointmentDetails.type !== 'online'"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-domain</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span v-if="appointmentDetails.subject">{{ appointmentDetails.subject }}</span>
                                <span v-else>Appointment</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <span v-if="appointmentDetails.type === 'online'">Online</span>
                                <span v-else>
                                        {{ appointmentDetails.clinic.name }} <br>
                                        {{ appointmentDetails.clinic.address }}
                                    </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item>
                        <v-list-item-icon>
                            <v-icon>mdi-thermometer-lines</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                Problems
                            </v-list-item-title>
                            <template v-if="appointmentDetails.problem != null || appointmentDetails.symptoms.length >0">
                                <v-list-item-subtitle class="mb-3 mt-2">
                                <v-chip small class="mr-2" :key="symptomKey" v-for="(symptom, symptomKey) in appointmentDetails.symptoms">
                                    {{symptom.name}}
                                </v-chip>                            
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    {{ appointmentDetails.problem }}
                                </v-list-item-subtitle>
                            </template>                        
                            <v-list-item-subtitle v-else>
                                <i>NA</i>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                        <v-list-item-icon>
                            <v-icon>mdi-receipt</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list >
                                <v-list-item-title >
                                Bills
                                </v-list-item-title>
                                <v-list-item class="pl-0"  :key="billKey" v-for="(bill, billKey) in appointmentDetails.bills">
                                    <v-row>
                                        <v-col cols="12" sm="4" md="6">
                                            <v-list-item-subtitle>                                                   
                                                ₹ {{ bill.total_amount }} |
                                                <template v-if="bill.type===0">Consultation</template>                             
                                                <template v-if="bill.type===1">Service</template> |
                                                <v-chip style="min-width:70px;" small class="mr-2 justify-center">
                                                    <template v-if="bill.status==0">Unpaid</template>                                            
                                                    <template v-else-if="bill.status==1">Paid</template>                                            
                                                </v-chip>
                                            </v-list-item-subtitle>
                                        </v-col>

                                        <v-col cols="12" sm="8" md="6" class="text-right pr-0">
                                            <v-btn outlined color="blue" @click="downloadBill(bill)" small> Download
                                            </v-btn>
                                            
                                        </v-col>
                                        
                                    </v-row>
                                    
                                    
                                </v-list-item>
                                
                            </v-list>
                            
                            
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                            v-if="appointmentDetails.note && appointmentDetails.note.share == 1" 
                            two-line="true"                            
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-note</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>                                
                                <span>Notes</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <span>{{appointmentDetails.note.note}}</span>                                                                
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions v-if="showActions" class="pb-3 pt-0">

                <v-spacer></v-spacer>            
                <v-btn                                 
                    @click="openTicketDialog = true" 
                    v-if="!hideTicket && canRaiseTicket(appointmentDetails)"
                    outlined 
                    small                                
                    class="mr-2">Raise Ticket
                </v-btn>   
                
            </v-card-actions>
        </v-card>
        <v-dialog
                    v-model="showRescheduleDialog"
                    scrollable
                    :overlay="false"
                    max-width="500px"
                    class="white"
                    color="white"
                    transition="dialog-transition"
                >
                    <v-card  v-if="showRescheduleDialog" class="white">
                        <v-row no-gutters class="white">
                            <v-col cols="12" class="pl-4 pt-2 pb-0">
                                <span class="subtitle-1 font-weight-bold">
                                    Reschedule Appointment
                                </span>
                            </v-col>
                            <v-col cols="12" class="pb-0">
                                <v-card flat style="border-radius: 6px 0 0 0;">
                                    <v-card-text>
                                        <date-picker v-model="selectedDate"></date-picker>
                                    </v-card-text>
                                </v-card>
                                <v-card flat class="mt-1" v-if="scheduleLoading">
                                    <v-col cols="12">
                                        Loading slots...
                                    </v-col>
                                </v-card>
                                <v-card flat class="mt-1" v-else-if="!slotsData.length">
                                    <v-col cols="12">
                                        No schedule set for Today
                                    </v-col>
                                </v-card>
                                <v-chip-group
                                    column
                                    active-class="white--text primary"
                                    v-else
                                >
                                    <v-row no-gutters>
                                        <v-col cols="12" :style="key === slotsData.length - 1 ? 'border-radius: 0 0 0 6px;' : ''" v-for="(schedule,key) in slotsData" :key="`sch${key}`" class="mt-1 pa-0">
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-col sm="12" class="py-0 pl-0">
                                                        <span class="subtitle-2 font-weight-bold">{{ schedule.start_time | time }} to {{ schedule.end_time | time }}</span>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" class="pt-1" v-if="availableSlots(schedule).length">
                                                        <v-row justify="start">
                                                            <v-chip
                                                            style="min-width:80px"
                                                                color="#e4eaed"
                                                                text-color="#334F5F"
                                                                v-for="(slot, slotKey) in availableSlots(schedule)"
                                                                :key="slotKey"                                                                
                                                                class="mr-1 mb-1 text-center d-flex justify-center"
                                                                label
                                                                small
                                                                @click="selectDateTime(slot)"
                                                            >
                                                                <span class="align-self-center">{{ slot.start_time | time }}</span>
                                                            </v-chip>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" class="pt-1 pl-0" v-else>
                                                        No Available Slots
                                                    </v-col>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-chip-group>
                            </v-col>
                        </v-row>
                        <v-card-actions class="d-flex flex-column pr-4 pb-4 pt-0 white">
                            <v-row class="align-self-start">
                                <v-col cols="12" class="py-0">
                                    <span class="red--text body-1 align-self-start" v-if="selectSlotError">Please select a time slot</span>
                                </v-col>
                            </v-row>
                            <v-btn
                                color="darkButton"
                                class="black--text primary align-self-end"
                                @click="rescheduleAppointment"
                                :loading="createAppointmentLoader"
                                :disabled="createAppointmentLoader"
                            >
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
    </div>
    
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppointmentUtils from '../AppointmentUtils.js';
    import DatePicker from './DatePicker'
    import moment from 'moment-timezone';
    import OpenTicket from "@/components/OpenTicket";
    import AddReview from "@/components/AddReview";

    export default {
        name: 'AppointmentDetails',
        components: {
            AddReview,
          OpenTicket,
          DatePicker
        },
        props: ['appointmentDetailsProp', 'showActions','hideComplete','hideVideoCall','hideTicket'],
        
        computed: {
            ...mapGetters([          
                'userInfo',
                'snackbar'
            ]),
        },
        watch: {
            selectedDate() {
                this.getAppointmentSlots()
            },
        },
        filters: {
            time(value) {
                return moment(value).format('hh:mm a')
            }            
        },
        data: () => ({
            
          openTicketDialog: false,
          showTicketSnackbar: false,
            cancelAppointmentDialog:false,
            cancelAppointmentLoading:false,
            cancelAppointmentId:null,
            appointmentDetails:null,
            loading:false,
            noteDialog:false,

            showRescheduleDialog: false,
            selectedDate: '',
            scheduleLoading: false,
            slotsData: [],
            selectSlotError: false,
            createAppointmentLoader: false,
            startTime: null,
            endTime: null,
            completeLoader:false,
            cancelDetails:{
                showDialog:false,
                loading:false,
                selected_reason:null,
                reasons:[],
                note:"",
                other_reason:"",
                description:""
            },
            reviewObj:{
                showReviewDialog:false                
            }
        }),
        methods: {
            showDoctorDetails(){
            let url = process.env.VUE_APP_WEBSITE_URL+"/doctors/"+this.appointmentDetails.doctor.unique_no+"/"+this.getSlugFromString(this.appointmentDetails.doctor.name)
            window.open(url, '_blank');
            },            
            showReview(){
                this.reviewObj.showReviewDialog = true
            },
            dismissReview(){
                this.reviewObj.showReviewDialog = false
            },
            markAsComplete() {
                this.completeLoader = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/`+this.appointmentDetails.id+`/complete`)
                    .then((response) => {
                        if(response.data.status == 1){
                            this.getAppointmentDetails();                        
                            this.showReview()
                        }
                        else if (response.data.status == 2) {                            
                            this.getAppointmentDetails();                                                            
                        }                                                
                        this.$store.commit('showSnackbar', {message: response.data.message})
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.completeLoader = false                        
                    })
            },
            getCancellationReasons(){
                this.cancelDetails.loading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/cancel-reasons`)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.cancelDetails.reasons = response.data.data                                                        
                        }
                        
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.cancelDetails.loading = false
                    })
            },
            isConfirmCancelButtonDisabled(){
                console.log("BTN DISABLED")
                console.log((this.cancelDetails.selected_reason))
                if(!this.cancelDetails.selected_reason)
                    return true
                else if(this.cancelDetails.selected_reason.action == 'other' && !this.cancelDetails.other_reason)
                    return true
                else 
                    return false
            },
          closeTicketDialog(value) {
            this.openTicketDialog = false
            if(value)
              this.showTicketSnackbar = true
          },
            gotoVideo(appointment) {
                this.$router.push({
                    name: 'appointmentCall', params: {
                        appointmentId: appointment.id
                    }
                })
            },
            canReschedule(appointment) {
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canReschedule()                
            },            
            canInitiateCall(appointment) {
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canVideoCall()                
            },          
            canGiveFeedback(appointment) {
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canGiveFeedback()                
            },    
            canRaiseTicket(appointment) {
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canRaiseTicket()                
            },     
            shouldShowCancel(appointment){                                
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canCancel()  
            },
            canShowMarkAsComplete(appointment){                                
                var appointmentUtils = new AppointmentUtils(appointment)                
                return appointmentUtils.canMarkAsComplete() && !this.hideComplete 
            },
            cancelRequestMessage(){
                console.log("CANCEL REQUEST")
                console.log(this.appointmentDetails.cancel_request)
                if(this.appointmentDetails.cancel_request !== null){
                    if(this.appointmentDetails.cancel_request === 0)
                        return "Your cancellation request is awaiting approval"
                    else if(this.appointmentDetails.cancel_request === 1)
                        return "Your cancellation request has been approved"
                    else if(this.appointmentDetails.cancel_request === 2)
                        return "Your cancellation request has been rejected"
                }
            },
            cancelAppointment() {
                this.cancelAppointmentLoading = true
                var cancelObj = {
                    reason:this.cancelDetails.selected_reason,
                    other_reason:this.cancelDetails.other_reason,
                    description:this.cancelDetails.description
                }
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/appointments/patient/` + this.cancelAppointmentId + `/cancel`,cancelObj)
                .then((response) => {
                    if (response.data.status == 1) {
                        this.cancelDetails.showDialog = false
                        this.getAppointmentDetails();                        
                    }
                    else if (response.data.status == 2) {
                        this.cancelDetails.showDialog = false
                        this.getAppointmentDetails();                                                        
                    }
                    this.$store.commit('showSnackbar', {message: response.data.message})
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.cancelAppointmentLoading = false
                })
            },
            showCancelAppointmentDialog(appointment){
                this.getCancellationReasons()
                this.cancelAppointmentId = appointment.id;
                this.cancelDetails.showDialog = true                
            },
            downloadBill(bill) {                
                var url = process.env.VUE_APP_API_URL + "/api/bills/" + bill.id + "/download"
                window.open(url, "_blank");                
            },
            getAppointmentDetails(){
                this.loading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/` + this.appointmentDetailsProp.id)
                .then((response) => {
                    if (response.data.status === 1) {
                        this.appointmentDetails = response.data.data            
                        this.$emit('update-appointment', this.$event, this.appointmentDetails)
                    }
                    else{
                        this.$emit('no-appointment', this.$event, this.appointmentDetails)                                    
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
                })
            },
            availableSlots(schedule) {
                return schedule.slots.filter((slot) => slot.is_available === 1)
            },
            selectDateTime(slot) {
                this.startTime = slot.start_time
                this.endTime = slot.end_time
            },
            rescheduleAppointment() {
                if(this.startTime === null || this.startTime === undefined) {
                    this.selectSlotError = true
                } else {
                    this.createAppointmentLoader = true
                    let appointment = {}
                    appointment.start_time = this.dateutils.toUtcString(this.startTime)
                    appointment.end_time = this.dateutils.toUtcString(this.endTime)
                    this.axios.post(`${process.env.VUE_APP_API_URL}/api/appointments/${this.appointmentDetails.id}/patient/reschedule`, appointment).then((response) => {
                        
                        if (response.data.status == 1) {
                            this.appointmentDetails.start_time = response.data.data.start_time
                            this.appointmentDetails.end_time = response.data.data.end_time
                            this.showRescheduleDialog = false
                            this.$store.commit('showSnackbar', {message: response.data.message})
                        }
                            else if (response.data.status == 2) {                            
                            this.getAppointmentDetails();                                
                            this.$store.commit('showSnackbar', {message: response.data.message, color: ''})                                                
                        }

                    }).finally(() => {
                        this.createAppointmentLoader = false
                    })
                }
            },
            getAppointmentSlots() {
                this.scheduleLoading = true
                var clinic_id = null
                var is_online = this.appointmentDetails.type === 'online' ? 1 : 0;
                if(this.appointmentDetails.type === 'clinic')
                    clinic_id = this.appointmentDetails.clinic.id

                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/availability`,
                    {
                        params: {
                            start_date: this.selectedDate,
                            end_date: this.selectedDate,
                            is_online: is_online,
                            doctor_id: this.appointmentDetails.doctor.id,
                            timezone:this.$store.getters.timezone,
                            clinic_id:clinic_id
                        }
                    })
                    .then((response) => {
                        this.slotsData = response.data.data
                    })
                    .finally(() => {
                        this.scheduleLoading = false
                    })
            },
            
        },
        mounted(){
            

            this.appointmentDetails = this.appointmentDetailsProp
            this.getAppointmentDetails()
            
            if(this.$route.query.action == 'reschedule'){
                if(this.canReschedule(this.appointmentDetails))
                    this.showRescheduleDialog = true
            }            
                
            
        },
        
    }
</script>
